// @flow

export const TAXI = "taxi";
export const RENTALS = "rentals";
